const zh = {
	project: '项目',
	number: '编号',
	projectList: '项目列表',
	searchCriteria: '搜索条件',
	pEnterName: '请输入名称',
	printerInformation: '印刷商信息',
	name: '名称',
	domainName: '域名',
	empty: '清空',
	search: '搜索',
	projectName: '项目名称',
	splitServer: '分端服务器',
	startAndEndTime: '起止时间',
	state: '状态',
	speedOfProgress: '进度',
	overview: '概览',
	currentProject: '目前项目',
	projectExperience: '项目经历',
	projectOverview: '项目概览',
	projectManager: '项目经理',
	removed: '已移除',
};

export default zh;
